// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"77e67c48","287":"b154d54e","368":"b988c37d","642":"7a356dbc","817":"39ffd529"}[chunkId] + ".chunk.js";
};